import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AlertSearchFilter from "../../../Presentational/ItemSearchPiece/AlertSearchFilters";
import ActivityFeed from "../../../Presentational/ActivityItem/ActivityFeed";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import ActivityService from "../../../../Services/Activity.service";
const AdvisorStudentsStudentAlertTab = (props) => {
    var _a, _b, _c, _d;
    const [alertSearch, setAlertSearch] = React.useState(
    // Error with casting an inexact object literal to exact type.  Have to cast through any
    {
        pipelines: !((_b = (_a = props.opportunity) === null || _a === void 0 ? void 0 : _a.stage) === null || _b === void 0 ? void 0 : _b.pipeline)
            ? []
            : [props.opportunity.stage.pipeline],
    });
    React.useEffect(() => {
        var _a, _b;
        setAlertSearch({
            pipelines: !((_b = (_a = props.opportunity) === null || _a === void 0 ? void 0 : _a.stage) === null || _b === void 0 ? void 0 : _b.pipeline)
                ? []
                : [props.opportunity.stage.pipeline],
        });
    }, [(_d = (_c = props.opportunity) === null || _c === void 0 ? void 0 : _c.stage) === null || _d === void 0 ? void 0 : _d.pipeline]);
    const itemSearch = React.useMemo(() => {
        var _a, _b, _c, _d;
        if (alertSearch) {
            return {
                global: {
                    contextPeoplePersonIds: [props.student.personId],
                    createdDateFrom: alertSearch.createdDateFrom,
                    createdDateTo: alertSearch.createdDateTo,
                    createdByPeoplePersonIds: (_a = alertSearch.creators) === null || _a === void 0 ? void 0 : _a.map((creator) => creator.personId),
                    activityItemTypeIds: [ActivityItemTypeService.PersonAlertId],
                    pipelineIds: (_b = alertSearch.pipelines) === null || _b === void 0 ? void 0 : _b.map((pipeline) => pipeline.id),
                },
                latestValue: [
                    {
                        types: (_c = alertSearch.alertTypes) === null || _c === void 0 ? void 0 : _c.map((type) => type.id),
                        subTypes: (_d = alertSearch.alertReasons) === null || _d === void 0 ? void 0 : _d.map((reason) => reason.id),
                        itemStatusIds: alertSearch.status ? [alertSearch.status.id] : null,
                        updatedDateTo: alertSearch.updatedDateTo,
                        updatedDateFrom: alertSearch.updatedDateFrom,
                    },
                ],
            };
        }
        return {
            global: {
                contextPeoplePersonIds: [props.student.personId],
                activityItemTypeIds: [ActivityItemTypeService.PersonAlertId],
            },
            latestValue: [],
        };
    }, [alertSearch, props.student.personId]);
    const poll = React.useCallback(() => ActivityService.areThereRecentEventsForPerson(props.student.personId), [props.student.personId]);
    return (_jsx(ActivityFeed, { search: itemSearch, filterComponent: _jsx(AlertSearchFilter, { onSearch: setAlertSearch, opportunity: props.opportunity }), poll: poll }));
};
export default AdvisorStudentsStudentAlertTab;
